// extracted by mini-css-extract-plugin
export var root = "aaf5d64ab31ac3441cb2e171ad4ca1b4-css";
export var linkIcon = "_5449720699ffb1c746b703f9f200b8d8-css";